module.exports = __webpack_public_path__ + "static/media/me.52286a2a.png";